import Lenis from 'lenis';
import { createContext, useContext, useEffect, useRef } from 'react';
import { useMotionValue } from 'framer-motion';

const ScrollContext = createContext(null);

export function ScrollProvider({ children }) {
  const scrollY = useMotionValue(0);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 1, smoothTouch: false });
    lenisRef.current = lenis;
    lenis.on('scroll', ({ scroll }) => scrollY.set(scroll));

    let raf;
    const tick = (t) => { lenis.raf(t); raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);

    return () => { cancelAnimationFrame(raf); lenis.destroy(); lenisRef.current = null; };
  }, [scrollY]);

  return <ScrollContext.Provider value={{ scrollY, lenisRef }}>{children}</ScrollContext.Provider>;
}

export const useScrollY = () => useContext(ScrollContext).scrollY;
export const useLenisRef = () => useContext(ScrollContext).lenisRef;
